import React from "react";
import { object } from "prop-types";

import WideStoryCard from "../../molecules/WideStoryCard";
import ComponentContainer from "../../layouts/component-container";
import CustomSlider from "../../atoms/CustomSlider";

import { componentProps } from "../../utils/utils";
import { useDevice } from "../../utils/react-utils";

import "./oneColThreeStoriesSlider.m.css";

const OneColThreeStoriesSlider = ({ collection }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const { mobile } = useDevice();

  const { items = [], autoPlay = false, showDots = true, numberOfStoriesShow = 3 } = componentProps(collection);

  const stories = items
    .filter(({ type }) => type === "story")
    .slice(0, numberOfStoriesShow)
    .map(({ story }) => story);

  if (!stories.length) return null;

  const children = stories.map((story, index) => (
    <WideStoryCard
      key={index}
      story={story}
      aspectRatio={mobile ? [3, 2] : [8, 3]}
      widths={[360, 860, 1248]}
      imageType={mobile ? "image3x2" : "image8x3"}
    />
  ));

  return (
    <ComponentContainer styleName="wrapper" collection={collection}>
      <div styleName="story">
        <CustomSlider
          isNavigation={showDots && !mobile}
          isPagination={showDots}
          isAutoplay={autoPlay}
          interval={3000}
          slidesPerView={{ mobileSlides: 1, tabSlides: 1, desktopSlides: 1 }}
          spacing={{ mobileSpace: 16, tabSpace: 16, desktopSpace: 16 }}
        >
          {children}
        </CustomSlider>
      </div>
    </ComponentContainer>
  );
};

OneColThreeStoriesSlider.propTypes = {
  collection: object,
};

OneColThreeStoriesSlider.storyLimit = 8;

export default OneColThreeStoriesSlider;
